import React, { useState } from 'react';
import { MDBContainer } from 'mdb-react-ui-kit';
import { useNavigate } from 'react-router-dom';
import { Avatar } from 'antd';
import axios from 'axios';

const ResetPassword = (props) => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  const handleLogin = () => {
    navigate('/login');
  };

  const handleLoginNext = async (e) => {
    e.preventDefault();
  
    if (!validateEmail(email)) {
      setEmailError('Please enter a valid email address');
    } else {
      setEmailError('');
      try {

        const apivalue = props.apiHost
        const baseUrl = `https://api.${apivalue}/mis/forget-password`;
const finalUrl = baseUrl + window.getLocalApiQuery(baseUrl);

        const response = await axios.post(
         finalUrl , // Update the URL here
  
          {
            email,
          },
          {
            headers: {
              Authorization: 'Bearer UXVpUGVja0BBUElAS0VZQEZPUkBEQVRBQE1JTklORzkxNTY2', // Update the token here
            },
          }
        );
  
        // Handle the response, such as displaying a success message to the user
        console.log('Reset password email sent:', response.data);
  
        navigate('/transport');
      } catch (error) {
        // Handle the error, such as displaying an error message to the user
        console.error('Error sending reset password email:', error);
      }
    }
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };



console.log("props.apiHost",props.apiHost)


  return (
    <>

<style>

  
        {`
          .custom-placeholder::placeholder {
            color: #FFFFFF; 
            
            
          }
        `}
      </style>


    <div style={{overflow:"hidden"}}>
      <div className="background-image-reset-password" style={{height:"100vh",display:"flex", alignItems:"center",flexDirection:"column"}}>
        <MDBContainer breakpoint="p-4 w-100">
          <div className="main-wrapper">
            <div>
              {/* old */}
              {/* <div
                className="navebar"
                style={{ background: '', width: '100%', marginBottom: '20px' }}
              >
                <img className="logo" src={window.logo} alt="logo" />
                <Avatar className="profile" alt="Remy Sharp" src={window.profile} />
              </div> */}
              {/* <h1 className="Login-Profile">Reset Password</h1> */}
              <div
                className="navebar"
                style={{ background: '', width: '100%', marginBottom: '20px',display:"flex",justifyContent:"center" }}
              >
                <img className="logo mb-3" src={window.logo} alt="logo" style={{width:"200px",paddingTop:"260px"}} />
               
              </div>

              <div className="" style={{ width: '100%' }}>
                <form className='px-2 pt-5'>
                  <div>
                    <label htmlFor="exampleInputEmail1" className="furas-input-label px-2 ">
                      Enter your E-mail Address
                    </label>
                    <div className="email-input-icons ">
                      <i className="fa fa-envelope email-icon"></i>
                      <input
                        className="email-input-field  bg-dark text-light custom-placeholder opacity-50  " style={{
                          borderRadius:"100px"
                          
                        }}
                        
                        type="text"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    {emailError !== '' && <p className="error-message text-danger px-4">{emailError}</p>}
                  </div>

<div className='px-4'>

<button
                    type="submit"
                    className="Login-btn-submit"
                    onClick={handleLoginNext}
                  >
                    Submite
                  </button>
                  <button type="submit" className="Login-btn-cancel" onClick={handleLogin}>
                    back
                  </button>
</div>
                
                </form>
              </div>
            </div>
          </div>
        </MDBContainer>
      </div>
    </div>
    </>
  );
};

export default ResetPassword;
